import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';

import './less/App.less';

import Home from './scenes/Home';
import RegisterFromInvitation from './scenes/RegisterFromInvitation';
import Login from './scenes/Login';
import ForgotPassword from './scenes/ForgotPassword';
import UpdatePassword from './scenes/UpdatePassword';
import TwoFactorCode from './scenes/TwoFactorCode';
import SignUp from './scenes/SignUp';
import SignUpChooser from './scenes/SignUpChooser/SignUpChooser';
import EuLoginCallback from './scenes/EuLoginCallback';

const App = () => (
  <Router>
    <div className='App'>
      <Route exact path='/login' component={Home} />
      <Route exact path='/sign-up' component={SignUpChooser} />
      <Route exact path='/sign-up-to' component={SignUp} />
      <Route exact path='/register/:uuid' component={RegisterFromInvitation} />
      <Route exact path='/' component={Login} />
      <Route exact path='/forgot-password' component={ForgotPassword} />
      <Route
        exact
        path='/password/update/:changePasswordId'
        component={UpdatePassword}
      />
      <Route exact path='/twoFactor' component={TwoFactorCode} />
      <Route exact path='/eu-login-callback' component={EuLoginCallback} />
    </div>
  </Router>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js